import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { CoverageExact } from '../../../../../mission/models/Coverage';

const CoverageTreeView = ({ coverage, setCoverage, setCenteredGeometries, disabled }) => {
  const handleCoverageCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(coverage, item.id));
    },
    [coverage, setCenteredGeometries]
  );

  const handleCoverageVisibilityClick = useCallback(
    (item, isToggled) => {
      setCoverage((oldCoverage) => getEntitiesWithVisibility(oldCoverage, item.id, isToggled));
    },
    [setCoverage]
  );

  const { current: coverageItemActions } = useRef([
    { id: 'coverage-center', icons: { default: 'gps_fixed' }, onClick: handleCoverageCenterClick },
    {
      id: 'coverage-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleCoverageVisibilityClick,
    },
  ]);

  const coverageItems = useMemo(
    () => [
      {
        id: 'root',
        label: i18n.t('patrol.details.coverage'),
        actions: coverageItemActions,
        disabled,
      },
    ],
    [coverageItemActions, disabled]
  );

  return <TreeView id="coverage" items={coverageItems} />;
};

CoverageTreeView.propTypes = {
  coverage: PropTypes.arrayOf(CoverageExact),
  setCoverage: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CoverageTreeView.defaultProps = {
  coverage: [],
  disabled: false,
};

export default CoverageTreeView;
